import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const PHASE_LABELS = {
  designing: '1 de 2 · Diseñando',
  executing: '2 de 2 · Calculando mosaicos',
  repairing: '2 de 2 · Corrigiendo mosaicos'
};

const StatusIcon = ({ status }) => {
  if (status === 'ok') return <CheckCircleIcon fontSize="small" sx={{ color: 'var(--wb-success)' }} aria-label="Listo" />;
  if (status === 'error') return <ErrorOutlineIcon fontSize="small" sx={{ color: 'var(--wb-warning)' }} aria-label="Con error" />;
  return <RadioButtonUncheckedIcon fontSize="small" sx={{ color: 'var(--wb-text-ghost)' }} aria-label="Pendiente" />;
};

/** Progreso de un tablero mientras se genera (estado de dashboardProgress.js). */
const DashboardProgress = ({ progress }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{ p: 2, borderRadius: 2, border: '1px solid var(--wb-border-20)', backgroundColor: 'var(--wb-overlay-08)', maxWidth: 720 }}
  >
    <Stack direction="row" spacing={1.5} alignItems="center">
      <CircularProgress size={20} sx={{ color: 'var(--wb-accent)' }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" sx={{ color: 'var(--wb-accent)', fontWeight: 600, letterSpacing: 0.4 }}>
          TABLERO · {PHASE_LABELS[progress.phase] || ''}
        </Typography>
        <Typography variant="body2" sx={{ color: 'var(--wb-text-strong)' }}>{progress.label}</Typography>
      </Box>
    </Stack>
    {progress.title && (
      <Typography variant="body2" sx={{ color: 'var(--wb-text-soft)', mt: 1.5 }}>{progress.title}</Typography>
    )}
    {progress.tiles.length > 0 && (
      <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, mt: 1 }} aria-label="Mosaicos del tablero">
        {progress.tiles.map((tile) => (
          <Stack component="li" key={tile.id} direction="row" spacing={1} alignItems="center" sx={{ py: 0.4 }}>
            <StatusIcon status={tile.status} />
            <Typography variant="body2" sx={{ color: tile.status === 'pending' ? 'var(--wb-text-soft)' : 'var(--wb-text-strong)' }}>
              {tile.title}
            </Typography>
          </Stack>
        ))}
      </Box>
    )}
  </Box>
);

export default DashboardProgress;
